import { Users } from 'lucide-react'
import { ReportPageLayout, type ReportColumn, type SummaryStat } from './ReportPageLayout'
import { generateCustomerGrowthReport } from '@/src/lib/api/admin-reports'
import type { CustomerGrowthReportData } from '@/src/types/admin/reports'

const fmtN = (v: unknown) => Number(v ?? 0).toLocaleString('th-TH')

const columns: ReportColumn[] = [
  { key: 'month', label: 'เดือน' },
  { key: 'new_customers', label: 'ลูกค้าใหม่', format: fmtN },
  { key: 'paid_customers', label: 'ลูกค้าชำระแล้ว', format: fmtN },
]

function extractRows(data: unknown) {
  const d = data as CustomerGrowthReportData
  return (d?.monthly_growth ?? []) as unknown as Record<string, unknown>[]
}

function extractSummary(data: unknown): SummaryStat[] {
  const d = data as CustomerGrowthReportData
  const totalNew = d?.monthly_growth?.reduce((s, r) => s + Number(r.new_customers ?? 0), 0) ?? 0
  const kyc = d?.kyc_funnel
  const stats: SummaryStat[] = [
    { label: 'ลูกค้าใหม่รวม', value: fmtN(totalNew) },
  ]
  if (kyc) {
    stats.push({ label: 'ลงทะเบียนแล้ว', value: fmtN(kyc.registered) })
    stats.push({ label: 'ยื่น KYC', value: fmtN(kyc.kyc_submitted) })
    stats.push({ label: 'อนุมัติ KYC', value: fmtN(kyc.kyc_approved) })
  }
  return stats
}

export default function AdminReportCustomers() {
  return (
    <ReportPageLayout
      title="รายงานการเติบโตของลูกค้า"
      description="ลูกค้าใหม่, churned, KYC funnel, สัดส่วนแพ็กเกจ"
      audience="ผู้บริหาร / การตลาด"
      icon={Users}
      columns={columns}
      fetchFn={generateCustomerGrowthReport}
      extractRows={extractRows}
      extractSummary={extractSummary}
      filenamePrefix="customer_growth"
    />
  )
}
